import React, { useEffect, useState } from "react";
import { Alert, Col, Form, Row, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  editFactorQuestion,
  getFactorQuestion,
  saveFactorQuestion,
} from "../../redux/evaluacion_desempenio/FactorQuestion/actions";

const Question = (props) => {
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [saveLoaderEdit, setSaveLoaderEdit] = useState(false);
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [error, setError] = useState("");
  const [formError, setFormError] = useState("");
  const [indexT, setIndexT] = useState(0);
  const [timer, setTimer] = useState(null);

  const dispatch = useDispatch();

  //Metodos
  useEffect(() => {
    // if (
    //   props.functionSelected &&
    //   !props._viewMessege
    // &&
    // props.positionSelected
    // ) {
    dispatch(
      getFactorQuestion(
        {
          tipo_busqueda: "encabezado",
          filter: props.idPlantilla,
          // tipo_busqueda: "posicion",
          // filter: props.functionSelected.id,
          // filter: props.functionSelected.id,
          tipo_busqueda_2: "factor",
          filter_2: props.item.id,
          // tipo_busqueda_3: "factor",
          // filter_3: props.item.id,
        },
        setData,
        setCount,
        setLoader,
        setError,
        setFormError
      )
    );
    // }
  }, [props.functionSelected, props._viewMessege]);

  useEffect(() => {
    if (props.resetFunction) {
      setData([]);
      setCount(0);
    }
  }, [props.resetFunction]);

  const handleSubmit = (pregunta, id_factor, tempFactor, tempValIndex) => {
    const req = {
      // posicion: props.functionSelected.id,
      // posicion: props.positionSelected.id,
      factor: id_factor,
      pregunta: pregunta,
      periodicidad: props.idPeriodicidad,
      factor_plantilla_encabezado: props.idPlantilla,
    };
    if (tempFactor === undefined) {
      dispatch(
        saveFactorQuestion(
          req,
          data,
          setData,
          count,
          setCount,
          setSaveLoader,
          setError,
          setFormError
        )
      );
    } else {
      dispatch(
        editFactorQuestion(
          req,
          tempFactor.id,
          tempValIndex,
          data,
          setData,
          count,
          setCount,
          setSaveLoaderEdit,
          setError,
          setFormError
        )
      );
    }
  };

  const Options = React.useCallback((val, ind) => {
    switch (props.index) {
      case 0:
        return (
          <Form.Control
            as="select"
            // id="factor"
            name="factor"
            className="col rounded-pill"
            defaultValue={
              data && data[val] !== undefined ? data[val].pregunta : ""
            }
            onChange={(e) => {
              setIndexT(ind)
              if (data && data[val] !== undefined) {
                handleSubmit(
                  e.currentTarget.value,
                  props.item.id,
                  data[val],
                  val
                );
              } else {
                handleSubmit(
                  e.currentTarget.value,
                  props.item.id,
                  undefined,
                  val
                );
              }
            }}
            disabled={
              props.functionSelected === null ||
              // props.positionSelected === null ||
              (props.functionSelected && props._viewMessege) ||
              // &&
              // props.positionSelected
              val > count ||
              error !== ""
            }
          >
            <option value="" selected></option>
            {props.jobFunctions.map((func) => (
              <option key={func.id} value={func.descripcion}>
                ¿
                {func.descripcion[0].toUpperCase() +
                  func.descripcion.substring(1)}
                ?
              </option>
            ))}
          </Form.Control>
        );
      case 1:
        return (
          <Form.Control
            as="select"
            // id="factor"
            name="factor"
            className="col rounded-pill"
            defaultValue={
              data && data[val] !== undefined ? data[val].pregunta : ""
            }
            onChange={(e) => {
              setIndexT(ind)
              if (data && data[val] !== undefined) {
                handleSubmit(
                  e.currentTarget.value,
                  props.item.id,
                  data[val],
                  val
                );
              } else {
                handleSubmit(
                  e.currentTarget.value,
                  props.item.id,
                  undefined,
                  val
                );
              }
            }}
            disabled={
              props.functionSelected === null ||
              // props.positionSelected === null ||
              (props.functionSelected && props._viewMessege) ||
              // &&
              // props.positionSelected
              val > count ||
              error !== ""
            }
          >
            <option value="" selected></option>
            {props.indikators &&
              props.indikators.data.map((ind) => (
                <option
                  key={ind.indicador}
                  value={ind.list_indicador[0].objetivo}
                >
                  ¿
                  {ind.list_indicador[0].objetivo[0].toUpperCase() +
                    ind.list_indicador[0].objetivo.substring(1)}
                  ?
                </option>
              ))}
          </Form.Control>
        );
      default:
        return (
          <Form.Control
            // id="factor"
            name="factor"
            className="col rounded-pill"
            defaultValue={
              data && data[val] !== undefined
                ? data[val].pregunta[0].toUpperCase() +
                data[val].pregunta.substring(1)
                : ""
            }
            onChange={(e) => {
              setIndexT(ind)
              const Value = e.currentTarget.value;
              if (timer) {
                clearTimeout(timer);
                setTimer(null);
              }
              setTimer(
                setTimeout(() => {
                  if (data && data[val] !== undefined) {
                    handleSubmit(Value, props.item.id, data[val], val);
                  } else {
                    handleSubmit(Value, props.item.id, undefined, val);
                  }
                }, 2000)
              );
            }}
            type="text"
            disabled={
              // props.functionSelected === null ||
              // props.positionSelected === null ||
              // (props.functionSelected && props._viewMessege) ||
              // &&
              // props.positionSelected
              val > count || error !== ""
            }
          />
        );
    }
  });

  return (
    <>
      {!!error && (
        <Alert variant="danger" className="mt-1 mb-2">
          {error}
        </Alert>
      )}
      {!!formError && (
        <Alert variant="danger" className="mt-1 mb-2">
          {formError}
        </Alert>
      )}
      {loader ? (
        <div className="d-flex justify-content-center">
          <Spinner
            animation="border"
            role="status"
            className="d-flex justify-content-center"
          />
        </div>
      ) : (
        [1, 2, 3].map((_item, _indexT) => (
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Pregunta {_item}
            </Form.Label>
            <Col sm={10}>
              <Row>
                {saveLoader && indexT === _indexT ? (
                  <div className="d-flex justify-content-center">
                    <Spinner
                      animation="border"
                      role="status"
                      className="d-flex justify-content-center"
                      size="sm"
                    />
                  </div>
                ) : (
                  <Col sm="12">{Options(parseInt(_indexT), _indexT)}</Col>
                )}
              </Row>
            </Col>
          </Form.Group>
        ))
      )}
    </>
  );
};

export default Question;
